import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import { BaseTextField, PBaseTextField } from './BaseTextField';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, IconButton } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  searchIco: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 11px',
  },
  searchIcoBtn: {
    padding: '0 !important',
  },
}));

type PSearchTextField = PBaseTextField & {
  onSearch?: () => void;
  icoBtn?: boolean;
  loading?: boolean;
};

export const SearchTextField: React.FC<PSearchTextField> = (props) => {
  const {
    InputProps,
    icoBtn = false,
    onSearch,
    loading,
    ...otherProps
  } = props;
  const classes = useStyles();

  const searchIcoDom = <SearchIcon style={{ color: '#BEBEBE' }} />;

  return (
    <BaseTextField
      InputProps={{
        endAdornment: (
          <div className={classes.searchIco}>
            {loading && <CircularProgress color="inherit" size={15} />}
            {icoBtn ? (
              <IconButton
                className={classes.searchIcoBtn}
                size="small"
                onClick={onSearch}
              >
                {searchIcoDom}
              </IconButton>
            ) : (
              searchIcoDom
            )}
          </div>
        ),
        ...InputProps,
      }}
      {...otherProps}
    />
  );
};
